import { SVGProps } from '@components/Icon/types';

export const Preview = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(3, 3)">
      <path
        d="M6 10C7.10457 10 8 10.8954 8 12V16C8 17.1046 7.10457 18 6 18H2C0.895431 18 0 17.1046 0 16V12C1.61067e-08 10.8954 0.895431 10 2 10H6ZM16 10C17.1046 10 18 10.8954 18 12V16C18 17.1046 17.1046 18 16 18H12C10.8954 18 10 17.1046 10 16V12C10 10.8954 10.8954 10 12 10H16ZM12 11.4004C11.6686 11.4004 11.4004 11.6686 11.4004 12V16C11.4004 16.3314 11.6686 16.5996 12 16.5996H16C16.3314 16.5996 16.5996 16.3314 16.5996 16V12C16.5996 11.6686 16.3314 11.4004 16 11.4004H12ZM2 11.4004C1.66863 11.4004 1.40039 11.6686 1.40039 12V16C1.40039 16.3314 1.66863 16.5996 2 16.5996H6C6.33137 16.5996 6.59961 16.3314 6.59961 16V12C6.59961 11.6686 6.33137 11.4004 6 11.4004H2ZM6 0C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2C1.61067e-08 0.895431 0.895431 1.61064e-08 2 0H6ZM16 0C17.1046 0 18 0.895431 18 2V6C18 7.10457 17.1046 8 16 8H12C10.8954 8 10 7.10457 10 6V2C10 0.895431 10.8954 1.61064e-08 12 0H16ZM2 1.40039C1.66863 1.40039 1.40039 1.66863 1.40039 2V6C1.40039 6.33137 1.66863 6.59961 2 6.59961H6C6.33137 6.59961 6.59961 6.33137 6.59961 6V2C6.59961 1.66863 6.33137 1.40039 6 1.40039H2ZM12 1.40039C11.6686 1.40039 11.4004 1.66863 11.4004 2V6C11.4004 6.33137 11.6686 6.59961 12 6.59961H16C16.3314 6.59961 16.5996 6.33137 16.5996 6V2C16.5996 1.66863 16.3314 1.40039 16 1.40039H12Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'preview';
